const action = 'message';

export const buildMessage = (type: string, data: any) => {
  return JSON.stringify({ action, type, data });
};
